module.exports = __webpack_public_path__ + "media/CN_001.fcfc2fc0.mp3";